import { memo, useEffect,  useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BzModal, BzModalBody, BzModalHeader } from "../../../components";
import { Col, Container } from "react-bootstrap";
import {
  APPLICATION_TYPE,
  APP_INFO_PARAMS,
  MARKET_SEGMENT_ID,
  WATCHLIST_GRID_INDEX,
} from "../../../utils/global_variables";
import { handleModal } from "../../../redux/actions/modals";
import {  getAppInfoData, getMktSegIdFromApiExchangeName } from "../../../utils/global_functions";
//Vaibhav Singh: 24-11-23:BT-106776: BrokerageModal for Spread and Multileg Implemented : Start
const BrokerageModalMultiLeg = ({ sentFrom, spreadOrderInfo, orderCartInfo }) => {
  const dispatch = useDispatch();
  const multiLegData = useSelector((state) => state.orders.multiLegData);
  const modals = useSelector((state) => state?.modals?.modals);
  const objLoginSession = useSelector((state) => state.auth.objLoginSession);
  const arrMarginInfo = useSelector((state) => state.orders.arrMarginInfo);
  const spreadOrderArr = useSelector(state => state.orders.spreadOrderInfo);
  const appInfo = useSelector(state => state?.appInfo?.appInfo);
  const [objBrokerage, setBrokerage] = useState("");



  useEffect(() => {
    if ((multiLegData?.length || spreadOrderArr?.length || orderCartInfo?.length) && modals["BROKERAGE_MULTILEG"]) {
      let LegDtls = [];
      if (sentFrom === "multileg") {
        for (let i = 0; i < multiLegData?.length; i++) {
          let jData_legDtls = {};
          let quantity =
            multiLegData[i]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] ===
              MARKET_SEGMENT_ID.NSE_DERIVATIVES ||
              multiLegData[i]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID] ===
              MARKET_SEGMENT_ID.NCDEX_DERIVATIVES
              ? multiLegData[i]?.count * multiLegData[i]?.ask_qty
              : multiLegData[i]?.ask_qty;
          jData_legDtls["LegIndicator"] = multiLegData.length === 2 ? 5 : 6; // 2leg=5, 3leg=6 , spread=4
          jData_legDtls["MarketSegmentId"] =
            multiLegData[i]?.extraInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID];
          jData_legDtls["Series"] = "XX"; //multiLegData[i]?.extraInfo?.[WATCHLIST_GRID_INDEX.SERIES];
          jData_legDtls["ProductType"] = "CARRYFORWARD";
          jData_legDtls["TransactionType"] = 1; //multiLegData[i].legbuysell.toUpperCase() === clsConstants.C_S_ORDER_BUY_TEXT ? 1 : 2;
          jData_legDtls["Quantity"] = quantity; //multiLegData?.[i]?.ask_qty;
          jData_legDtls["Price"] = multiLegData[i]?.legPrice; //((multiLegData[i].legpricetoggle == 'marketlegPrice' ? Math.round(parseFloat(multiLegData[i].selmarketlegPrice) * multiLegData[i].legDecimalLocator) : Math.round(parseFloat(multiLegData[i].sellimitlegPrice) * multiLegData[i].legDecimalLocator)) / 100).toFixed(2);
          jData_legDtls["Instrument"] = "FUTSTK"; //multiLegData[i].instrument;
          jData_legDtls["PriceLocator"] = 1; //this.calculateCVF();
          LegDtls.push(jData_legDtls);
        }
      }//BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 - Start
      else if (sentFrom === 'ordercart') {
        let arrBrokerageDetails = [];
        for (let i = 0; i < orderCartInfo?.length; i++) {
          let objBrokerageData = {};
          let quantity = orderCartInfo[i].count;
          objBrokerageData["LegIndicator"] = 1;
          objBrokerageData["MarketSegmentId"] = orderCartInfo[i].exchangeId;
          objBrokerageData["Series"] = orderCartInfo[i].series;
          objBrokerageData["ProductType"] = orderCartInfo[i].productType;
          objBrokerageData["TransactionType"] = 1;
          objBrokerageData["Quantity"] = quantity;
          objBrokerageData["Price"] = orderCartInfo[i].price;
          objBrokerageData["Instrument"] = orderCartInfo[i].instrument;
          objBrokerageData["PriceLocator"] = 1;
          arrBrokerageDetails.push(objBrokerageData);
        }
        LegDtls = [...arrBrokerageDetails];
      }
      //BT-126347 : Brokerage and Statutory changes - Order Cart : ManasaB : 19/01/2024 - End
      else {
        for (let i = 0; i < spreadOrderArr?.length; i++) {
          let jData_legDtls = {};
          let quantity = getMktSegIdFromApiExchangeName(spreadOrderInfo?.exchange) === MARKET_SEGMENT_ID.NSE_DERIVATIVES || getMktSegIdFromApiExchangeName(spreadOrderInfo?.exchange) === MARKET_SEGMENT_ID.NCDEX_DERIVATIVES ? spreadOrderInfo?.quantity * spreadOrderArr[i]?.nRegularLot : spreadOrderArr[i]?.nRegularLot;
          jData_legDtls["LegIndicator"] = 4; // 2leg=5, 3leg=6 , spread=4
          jData_legDtls["MarketSegmentId"] = getMktSegIdFromApiExchangeName(spreadOrderInfo?.exchange);
          jData_legDtls["Series"] = spreadOrderArr[i]?.sSeries; //multiLegData[i]?.extraInfo?.[WATCHLIST_GRID_INDEX.SERIES];
          jData_legDtls["ProductType"] = "CARRYFORWARD";
          jData_legDtls["TransactionType"] = 1; //multiLegData[i].legbuysell.toUpperCase() === clsConstants.C_S_ORDER_BUY_TEXT ? 1 : 2;
          jData_legDtls["Quantity"] = quantity; //multiLegData?.[i]?.ask_qty;
          jData_legDtls["Price"] = spreadOrderInfo?.amount; //((multiLegData[i].legpricetoggle == 'marketlegPrice' ? Math.round(parseFloat(multiLegData[i].selmarketlegPrice) * multiLegData[i].legDecimalLocator) : Math.round(parseFloat(multiLegData[i].sellimitlegPrice) * multiLegData[i].legDecimalLocator)) / 100).toFixed(2);
          jData_legDtls["Instrument"] = spreadOrderArr[i]?.sInstrumentName; //multiLegData[i].instrument;
          jData_legDtls["PriceLocator"] = 1; //this.calculateCVF();
          LegDtls.push(jData_legDtls);
        }
      }
      let form = document.createElement("form");

      let params = {
        Product: APPLICATION_TYPE,
        Theme: "L",
        UserId: objLoginSession?.data?.user_id,
        GroupId: objLoginSession?.data?.others?.groupId,
        SessionId: objLoginSession?.data?.others?.ocToken,
        //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: start
        Brokerage: arrMarginInfo?.Brokerage || 0.0,
        //Vaibhav Singh: 07-12-23: Display Brokerage Charges: arrMargin filed changes: End
        LegDetails: JSON?.stringify(LegDtls),
      };
      form?.setAttribute("name", "brokerageForm");
      form?.setAttribute("method", "post");
      form?.setAttribute(
        "action",
        `${objBrokerage?.url?.split('?')[0]}`
      );

      for (var i in params) {
        if (params.hasOwnProperty(i)) {
          var brokerageField = document.createElement("input");
          brokerageField.type = "hidden";
          brokerageField.name = i;
          brokerageField.value = params[i];
          form?.appendChild(brokerageField);
        }
      }
      form?.setAttribute("target", "TargetFrame");
      document.body.appendChild(form);
      document?.forms["brokerageForm"]?.submit();
      document?.forms["brokerageForm"]?.remove();
    }
  }, [multiLegData, modals["BROKERAGE_MULTILEG"]]);
  

  // Vinit R - 18-03-2024 Get brokerage url from app info for multi scrip -- Start
  useEffect(() => {
      const objBrokerageData = getAppInfoData(APP_INFO_PARAMS.APP_BROKERAGE_MODE)
      setBrokerage(objBrokerageData)
  }, [appInfo, setBrokerage])
  // Vinit R - 18-03-2024 Get brokerage url from app info for multi scrip -- End

  const handleClose = () => {
    dispatch(handleModal([{ 'BROKERAGE_MULTILEG': false }]));
  };

  return (
    <Container fluid className='p-0'>
      <BzModal data-testid='brokerage-modal' size='md' show={modals["BROKERAGE_MULTILEG"]} onHide={handleClose} centered>
        <BzModalHeader className='modaltabs-header'>
          <Col md={2} className='d-flex justify-content-end align-self-center w-100'>
            <div data-testid='brokerage-modal-close-icon' className='icon-16 icon-dark icon-close float-end ms-2 my-auto' onClick={handleClose}>&nbsp;</div>
          </Col>
        </BzModalHeader>
        <BzModalBody>
          <iframe
            name="TargetFrame"
            height="600px"
            width="100%"
          />
        </BzModalBody>
      </BzModal>
    </Container>
  );
};
//Vaibhav Singh: 24-11-23:BT-106776: BrokerageModal for Spread and Multileg Implemented : End
export default memo(BrokerageModalMultiLeg);

